import gql from 'graphql-tag';

export const createTagMutation = gql`
  mutation CreateDocumentTag($title: String!) {
    createTag(title: $title) {
      id
      title
      status
    }
  }
`;

export const addTagsMutation = gql`
  mutation AddDocumentTags($documentIds: [String!]!, $tagIds: [String!]!) {
    addDocumentTags(documentIds: $documentIds, tagIds: $tagIds) {
      tag {
        id
      }
      document {
        id
      }
    }
  }
`;

export const removeTagsMutation = gql`
  mutation RemoveDocumentTags($documentIds: [String!]!, $tagIds: [String!]!) {
    removeDocumentTags(documentIds: $documentIds, tagIds: $tagIds)
  }
`;
